import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ModalContent, useModal } from "../Shared/components/Modal";
import Stack from "@mui/material/Stack";
import { MuiMarkdown_V2 } from "../Shared/components/MuiMarkdown/MuiMarkdown_V2";
/**
 * Displays markdown with an info icon on mobile that opens a modal when clicked.
 * @param title - string
 * @param subtext - string | undefined
 * @returns
 */
export const InfoMarkdown = ({ subtext, markdown, modalTitle }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
    const { showModal } = useModal();
    return (_jsxs(Stack, Object.assign({ display: isMobile ? "flex" : "block", justifyContent: "center", flexDirection: "row", alignItems: "flex-start", sx: {
            hr: {
                maxWidth: "517px",
            },
        } }, { children: [_jsx(Box, Object.assign({ width: "100%" }, { children: _jsx(MuiMarkdown_V2, { children: markdown }) })), isMobile && subtext && (_jsx(IconButton, Object.assign({ size: "small", onClick: () => showModal({
                    title: (_jsx(Typography, Object.assign({ variant: "h4", color: "primary" }, { children: modalTitle }))),
                    content: (_jsx(ModalContent, { children: _jsx(MuiMarkdown_V2, { children: subtext }) })),
                }) }, { children: _jsx(InfoOutlinedIcon, { color: "info" }) })))] })));
};
